import React from "react";
import ShareColorControl from "./ShareColorControl";
import { Button, Form } from "react-bootstrap";

const ShareShadowControls = ({ shadow, defaults, onChange, idPrefix, title, directional = false }) => (
  <>
    {title && <div className="share-editor-control-title">{title}</div>}
    <Form.Check type="switch" id={`${idPrefix}-enabled`} label="Enable shadow" checked={shadow.enabled} onChange={(event) => onChange({ ...shadow, enabled: event.target.checked })} />
    {shadow.enabled && <>
      <Form.Label className="share-editor-label mt-3">Intensity <span>{Math.round(shadow.opacity * 100)}%</span></Form.Label>
      <Form.Range aria-label="Shadow intensity" min={0} max={1} step={0.01} value={shadow.opacity} onChange={(event) => onChange({ ...shadow, opacity: Number(event.target.value) })} />
      <Form.Label className="share-editor-label">Softness <span>{Math.round(shadow.blur)}px</span></Form.Label>
      <Form.Range aria-label="Shadow softness" min={0} max={64} step={1} value={shadow.blur} onChange={(event) => onChange({ ...shadow, blur: Number(event.target.value) })} />
      <details className="share-editor-placement">
        <summary>{directional ? "Color" : "Position & color"}</summary>
        {!directional && <>
        <Form.Label className="share-editor-label">Horizontal offset <span>{shadow.offsetX}px</span></Form.Label>
        <Form.Range aria-label="Shadow horizontal offset" min={-64} max={64} step={1} value={shadow.offsetX} onChange={(event) => onChange({ ...shadow, offsetX: Number(event.target.value) })} />
        <Form.Label className="share-editor-label">Vertical offset <span>{shadow.offsetY}px</span></Form.Label>
        <Form.Range aria-label="Shadow vertical offset" min={-64} max={64} step={1} value={shadow.offsetY} onChange={(event) => onChange({ ...shadow, offsetY: Number(event.target.value) })} />
        </>}
        <Form.Label htmlFor={`${idPrefix}-color`} className="share-editor-label">Color</Form.Label>
        <ShareColorControl id={`${idPrefix}-color`} value={shadow.color} onChange={(event) => onChange({ ...shadow, color: event.target.value })} />
      </details>
    </>}
    <Button variant="outline-light" size="sm" className="w-100 mt-3" onClick={() => onChange({ ...defaults })}>Reset shadow</Button>
  </>
);

export default ShareShadowControls;
